import { type BookingClient } from '../../../models/Scheduling'
import { clientDisplayName } from '../shared/schedulingDisplay'
import { hasClientEmail } from './clientEmailGaps'

export const UNSUBSCRIBE_NOTICE_SUFFIX =
  ' from booking invitations. Reach out from your own email instead: copy the booking link, push all to draft, or copy the email.'
export const UNSUBSCRIBE_TOOLTIP_TITLE = "Can't send invitation emails"
export const UNSUBSCRIBE_CALENDAR_TOOLTIP_TITLE = "Can't send calendar invite"
export const UNSUBSCRIBE_TOOLTIP_SUFFIX = ' Remove them from Clients to send from here.'

export interface ClientUnsubscribesInput {
  unsubscribed: BookingClient[]
  clients: BookingClient[]
}

const unsubscribedClientName = (client: BookingClient): string =>
  client.contactId != null ? clientDisplayName(client) : (client.email ?? clientDisplayName(client))

const unsubscribedSubject = ({ unsubscribed, clients }: ClientUnsubscribesInput): string => {
  if (unsubscribed.length > 0 && unsubscribed.length === clients.filter(hasClientEmail).length) {
    return 'All clients have unsubscribed'
  }
  if (unsubscribed.length === 1) {
    return `${unsubscribedClientName(unsubscribed[0])} has unsubscribed`
  }
  if (unsubscribed.length === 2) {
    return `${unsubscribedClientName(unsubscribed[0])} and ${unsubscribedClientName(unsubscribed[1])} have unsubscribed`
  }
  return `${unsubscribed.length} clients have unsubscribed`
}

export const unsubscribeNoticeText = (input: ClientUnsubscribesInput): string => `${unsubscribedSubject(input)}${UNSUBSCRIBE_NOTICE_SUFFIX}`

export const unsubscribeTooltipBody = (input: ClientUnsubscribesInput): string => `${unsubscribedSubject(input)}.${UNSUBSCRIBE_TOOLTIP_SUFFIX}`
